import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

class Error extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showCommonLoader: true
    }
  }

  render () {
    return (<section>
      {this.renderError()}
    </section>)
  }
  renderError () {
    if (this.props.error) {
      return (
        <div className='col1'>
          <div className='forms clear'>
            <h3 className='error'>Unable to Connect</h3>
            <div className='error redbox_err_all redbox_marg'>
              <ul>
                <li>Bad Device ID. The system administrator has been notified.</li>
              </ul>
            </div>
          </div>
        </div>
      )
    } else {
      return (<div />)
    }
  }
}

function mapStateToProps (state) {
  return {
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(Error)



// WEBPACK FOOTER //
// ./src/components/Actions/Error.js